module.exports = __webpack_public_path__ + "img/hodo-pro.423a8618.png";